import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthStore } from "../persistence/auth.store";
import { ComponentRoutes } from "../../routing/component-routes";

export const authorizedGuard: CanActivateFn = (route) => {
    const authStore = inject(AuthStore);
    const router = inject(Router);

    if (!authStore.isAuthorized()) {
        return router.createUrlTree([ComponentRoutes.auth.root]);
    }

    const path = route.routeConfig?.path;
    if (path === undefined || authStore.canAccess(path)) {
        return true;
    }

    const allowedRoute = authStore.allowedRoutes()?.[0];

    return allowedRoute ? router.createUrlTree(["/", allowedRoute]) : false;
};
